import { defineStore } from "pinia";
import { getTaxons } from "@/api/auth";
import { useDelegueStore } from "./delegueStore";
import { useRegisterStore } from "./register";

export const useGammesStore = defineStore("gammes", {
  state: () => ({
    gammes: [],
    firstcall: true,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchGammes() {
      if (this.firstcall) {
        this.loading = true;
      }
      try {

         const registerStore = useRegisterStore();
         const delegueStore = useDelegueStore();
         const userRole = registerStore.user?.role || "";
         const isDelegue = userRole === "delegues";
         const vetId = isDelegue ? delegueStore.getSelectedVeterinarian?.id : null;
         
         const response = await getTaxons(isDelegue, vetId);
         this.gammes = response.data;
         this.firstcall = false;
         this.loading = false;
         this.error = "";
      } catch (error) {
        this.error = "Erreur lors du chargement des gammes";
        this.loading = false;
        console.error("Failed to fetch gammes:", error);
      }
    },
  },
  persist: true,
});
